import React, { useState, useEffect } from 'react'
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    InputAdornment,
    FormControl,
    InputLabel,
    OutlinedInput,
    Alert
} from '@mui/material';

const DialogModifySolde = ({ onDialogClose, open, initialSolde, onSubmit, minSolde }) => {
    const [openDialog, setOpenDialog] = useState(false);

    const [solde, setSolde] = useState(0);
    const [soldeIsFocus, setSoldeIsFocus] = useState(false);
    const [soldeFormatEur, setSoldeFormatEur] = useState('0');

    const [formIsValid, setFormIsValid] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');
    const [infoMessage, setInfoMessage] = useState('');

    const handleSoldeInput = (inputNumber) => {
        const soldeMin = 0;
        const soldeMax = 1000000000;

        if (inputNumber >= soldeMin && inputNumber <= soldeMax) {
            setSolde(inputNumber)
        }
    }

    const handleFormatSolde = () => {

        let soldeReformat = Number(solde.toString());

        const soldeIsNotInteger = soldeReformat.toString().indexOf(".") !== -1;

        if (soldeIsNotInteger) {
            soldeReformat = soldeReformat.toFixed(2)
        }

        let soldeFormatString = new Intl.NumberFormat("fr-FR").format(soldeReformat);

        setSoldeFormatEur(soldeFormatString)
        setSolde(soldeReformat)

    }

    const handleCheckFormValidity = () => {
        if (solde !== initialSolde) {
            setFormIsValid(true)
        } else if (formIsValid) {
            setFormIsValid(false)
        }

        if (solde < minSolde) {
            setErrorMessage(`Attention, solde trop bas ! Nous vous conseillons de mettre un solde de minimum ${minSolde} €, ou alors, réajustez le solde de certains split.`)
        } else {
            setErrorMessage('')
        }
    }

    const handleCloseDialog = () => {
        onDialogClose()
        setSolde(0)
        setSoldeFormatEur('0')
        setFormIsValid(false)
        setErrorMessage('')
        setInfoMessage('')
    }

    const handleSubmit = () => {
        if (solde !== initialSolde) {
            onSubmit(solde)
            handleCloseDialog()
        }
    }

    useEffect(() => {
        setOpenDialog(open)
        if (open) {
            setSolde(initialSolde)
            setInfoMessage(`Nous vous conseillons de mettre un solde de minimum ${minSolde} €`)
        }

    }, [open])

    useEffect(() => {
        handleFormatSolde()
    }, [solde])

    return (
        <Dialog open={openDialog} onClose={() => handleCloseDialog()}>
            <DialogTitle>Solde total</DialogTitle>
            <DialogContent>
                <DialogContentText marginBottom={2}>
                    Modifier le solde total de ce projet.
                </DialogContentText>

                {errorMessage.length !== 0 ?
                    <Alert severity='error' sx={{ marginBottom: 3, alignSelf: 'flex-start' }}>
                        {errorMessage}
                    </Alert>
                    :
                    <Alert severity='info' sx={{ marginBottom: 3, alignSelf: 'flex-start' }}>
                        {infoMessage}
                    </Alert>
                }
                <FormControl fullWidth sx={{ m: 1 }}>
                    <InputLabel htmlFor="outlined-adornment-amount">Solde</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-amount"
                        type={soldeIsFocus ? 'number' : 'text'}
                        value={soldeIsFocus ? solde : soldeFormatEur}
                        onChange={e => {
                            handleSoldeInput(e.target.value)
                        }}
                        startAdornment={<InputAdornment position="start">€</InputAdornment>}
                        label="Solde"
                        onFocus={() => setSoldeIsFocus(true)}
                        onBlur={() => {
                            setSoldeIsFocus(false)
                            handleFormatSolde()
                            handleCheckFormValidity()
                        }}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleCloseDialog()}>Annuler</Button>
                <Button variant='contained' disabled={!formIsValid} onClick={() => handleSubmit()}>Valider</Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogModifySolde;